import iconProduto from '../assets/icons/drive/icon-defaut-product.svg'
import iconSoja from '../assets/icons/drive/icon-soja.svg'

export const iconProdutoLote = (produto: string): string => {
  if (!produto) return iconProduto

  const product = produto.toLowerCase()
  if (product === 'soja') return iconSoja

  return iconProduto
}
